import Select from "@components/core/Select";
import { ExpressionTypeSelectorProps } from "@customTypes/components/selectors/ExpressionTypeSelector";

import { ExpressionType, beadlSelector } from "@store/beadl";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { itemIdentifier, renderLabel } from "../util";

const ExpressionTypeSelector = (props: ExpressionTypeSelectorProps) => {
  const {
    selected,
    onChange,
    placeholder = "Select expression type",
    options,
    className,
    allowClear,
    onClear,
    disabled = false,
  } = props;

  const { expressionTypes: { data: expressionTypes } } = useSelector(beadlSelector);

  const handleChange = useCallback(
    (id: number, item?: ExpressionType) => {
      onChange && onChange(id, item);
    },
    [onChange]
  );

  return (
    <Select
      disabled={disabled}
      allowClear={allowClear}
      onClear={onClear}
      className={className}
      options={options || expressionTypes}
      selected={selected}
      onChange={handleChange}
      placeholder={placeholder}
      labelRender={(item) => renderLabel(item, "name")}
      itemIdentifier={(item) => itemIdentifier(item, "id")}
    />
  );
};

export default ExpressionTypeSelector;
